import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { Router, RouterModule } from '@angular/router';
import { WarrantyStatus } from '@models';
import { ApplicationService } from '@warranty/services';

@Component({
  selector: 'app-purchased-site',
  templateUrl: './purchasedSite.component.html',
  styleUrl: './purchasedSite.component.scss',
  imports: [CommonModule, MatButtonModule, RouterModule],
})
export class PurchasedSiteComponent {
  applicationService = inject(ApplicationService);
  router = inject(Router);

  @Output() site = new EventEmitter<string>();
  purchaseLocation = '';
  company = this.applicationService.company();
  companySite = this.applicationService.companySite;

  onSite(onSite: boolean) {
    this.purchaseLocation = onSite ? 'Site' : 'Other';
    if (!onSite) { this.site.emit(this.purchaseLocation); }
    else {
      void this.router.navigate(
        ['/action-complete', this.company],
        { queryParams: { status: WarrantyStatus.Registered, id1: '', id2: '' } }
      );
    }
  }

  onAlreadyRegistered() {
    void this.router.navigate(['/find-claim'], { queryParams: { company: this.company } });
  }
}
